module.exports = __webpack_public_path__ + "img/022-conversation.f840a6bf.png";